import {
  IntegrationAppProvider,
  useConnections,
  useIntegrations,
} from '@membranehq/react';
import { useEffect, useState } from 'react';
import { ContentWrapper } from 'src/components/ContentWrapper';
import { Heading } from 'src/components/Heading';
import useAuthedRequest from 'src/hooks/useAuthedRequest';
import { StabilityLevel } from 'src/types/stability-level';
import { IntegrationCard } from './IntegrationCard';
import { Input } from 'src/components/Input';
import { MagnifyingGlass } from '@phosphor-icons/react';

const DataMappingContent = () => {
  const { integrations } = useIntegrations();
  const { connections, refresh: refreshConnections } = useConnections();
  const [search, setSearch] = useState('');

  const sortedIntegrations = [...integrations]
    .filter((integration) =>
      integration.name.toLowerCase().includes(search.toLowerCase()),
    )
    .sort((a, b) => {
      const aConnected = connections.some(
        (connection) => connection.integrationId === a.id,
      );
      const bConnected = connections.some(
        (connection) => connection.integrationId === b.id,
      );
      if (aConnected && !bConnected) return -1;
      if (!aConnected && bConnected) return 1;
      return a.name.localeCompare(b.name);
    });

  return (
    <div className="flex-1">
      <Heading
        title="Data Mapping"
        subtitle="Map data from your CRM to Fluents properties"
        stabilityLevel={StabilityLevel.Experimental}
      />
      <ContentWrapper className="gap-4">
        <Input
          placeholder="Search"
          className="w-full"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          icon={<MagnifyingGlass size={20} />}
        />
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
          {sortedIntegrations.map((integration) => (
            <IntegrationCard
              key={integration.id}
              integrationId={integration.id}
              image={integration.logoUri}
              title={integration.name}
              integrationStatus={
                integration.state === 'READY' ? 'available' : 'unavailable'
              }
              connectionStatus={
                connections.some(
                  (connection) => connection.integrationId === integration.id,
                )
                  ? 'connected'
                  : 'disconnected'
              }
              onButtonClick={refreshConnections}
            />
          ))}
        </div>
      </ContentWrapper>
    </div>
  );
};

export const DataMapping = () => {
  const { get } = useAuthedRequest();
  const [token, setToken] = useState('');

  const getIntegrationAppToken = async () => {
    const response = await get('/account-connections/integration-app/token');

    if (response.token) setToken(response.token);
  };

  useEffect(() => {
    getIntegrationAppToken();
  }, []);

  return (
    <IntegrationAppProvider token={token}>
      <DataMappingContent />
    </IntegrationAppProvider>
  );
};
